<template>
  <div>
    <a-card style="margin-bottom: 10px">
      <div class="filter-section">
        <!-- <span>状态:</span>
        <a-select
          style="width: 140px"
          v-model:value="form.state"
        >
          <a-select-option key="全部" value="" title="全部">
            全部
          </a-select-option>
          <a-select-option key="已拒绝">
            已拒绝
          </a-select-option>
          <a-select-option key="已审核">
            已审核
          </a-select-option>
          <a-select-option key="标注中">
            标注中
          </a-select-option>
          <a-select-option key="已完成">
            已完成
          </a-select-option>
          <a-select-option key="未分配">
            未分配
          </a-select-option>
        </a-select> -->
        <a-form layout="inline" ref="form" :model="form">
          <a-form-item label="状态" name="state">
            <a-select
              style="width: 140px"
              v-model:value="form.state"
            >
              <a-select-option key="">
                全部
              </a-select-option>
              <a-select-option v-for="item in labelState" :key="item.state">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="名称" name="name">
            <a-input style="width: 200px" placeholder="请输入名称" v-model:value="form.name" autocomplete="off">
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-button @click="resetForm">重置</a-button>
            <a-button type="primary" @click="getData()">查询</a-button>
          </a-form-item>
        </a-form>
      </div>
    </a-card>
    <a-card>
      <a-table
        :columns="columns"
        :data-source="tableData"
        rowKey="id"
        :pagination="false">
        <template v-slot:taskType="{ text }">
          {{ getTaskName(text) }}
        </template>
        <template v-slot:userId="{ text }">
          {{ getUserName(text) }}
        </template>
        <template v-slot:stateName="{ text }">
          {{ getStateName(text) }}
        </template>
        <template v-slot:time="{ text }">
          {{ getDateTime(text) }}
        </template>
        <template v-slot:finishTime="{ text }">
          {{ getDateTime(text) }}
        </template>
        <template v-slot:action="{ record }">
          <span class="gap-btn">
            <a @click="openDetail(record)">详情</a>
          </span>
            <span class="gap-btn">
            <a :class="record.state == 'origin'?'':'grey'" @click="record.state == 'origin'?handleReceive(record):''">接收</a>
          </span>
            <span class="gap-btn">
            <a :class="record.state == 'origin'?'':'grey'" @click="record.state == 'origin'?handleReject(record):''">拒绝</a>
          </span>
          <!--<span v-else>
            <span class="gap-btn">
            <a class="grey">接收</a>
          </span>
          <span class="gap-btn">
            <a class="grey">拒绝</a>
          </span>
          </span>-->
        </template>
      </a-table>
      <br>
      <a-pagination
        :current="page.pageNum"
        show-quick-jumper
        :pageSize="10"
        :total="total"
        :show-total="total => `共 ${total} 条`"
        @change="getData"
      ></a-pagination>
    </a-card>
    <task-detail ref="taskDetail" :current-item="currentItem"></task-detail>
    <refuse-dialog ref="refuseDialog" @submit="refuse"></refuse-dialog>
    <!-- <AcceptDialog ref="acceptDialog"></AcceptDialog> -->
  </div>
</template>
<script>
// import { SearchOutlined } from '@ant-design/icons-vue'
import { getMyRelease, updateTask } from '@/api/task'
import { getDateTime, getTaskName, getStateName, getUserName } from '@/filters'
import RefuseDialog from './RefuseDialog'
import TaskDetail from '../TaskRelease/TaskDetail'
import { getAllData } from '@/api/dataSet'
import store from '@/store'
const columns = [
  {
    title: '名称',
    dataIndex: 'name'
  },
  {
    title: '任务类型',
    dataIndex: 'taskTypeId',
    slots: { customRender: 'taskType' }
  },
  {
    title: '说明',
    dataIndex: 'description'
  },
  {
    title: '状态',
    dataIndex: 'state',
    slots: { customRender: 'stateName' }
  },
  {
    title: '发布人',
    dataIndex: 'createUserId',
    slots: { customRender: 'userId' }
  },
  {
    title: '发布时间',
    dataIndex: 'createTime',
    slots: { customRender: 'time' }
  },
  {
    title: '要求完成时间',
    dataIndex: 'planFinishTime',
    slots: { customRender: 'finishTime' }
  },
  {
    title: '操作',
    slots: { customRender: 'action' }
  }
]

export default {
  components: {
    TaskDetail,
    RefuseDialog
    // SearchOutlined
  },
  data () {
    return {
      labelState: [
        { name: '待接收', state: 'origin' },
        { name: '已拒绝', state: 'already_deny' }],
      form: {
        state: '',
        name: ''
      },
      tableData: [],
      columns,
      page: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dialogType: '',
      currentItem: {},
      denyId: '',
      dataList: [],
      dataSetInfo: {}
    }
  },
  mounted () {
    this.getData(1)
    // this.getDataSetByPage(1)
  },
  methods: {
    getDateTime,
    getTaskName,
    getStateName,
    getUserName,
    resetForm () {
      this.$refs.form.resetFields()
    },
    getData (pageNum) {
      if (pageNum) this.page.pageNum = pageNum
      let s = ''
      if (this.form.state) {
        s = this.form.state
      } else {
        s = 'originviayieflagyieviaalready_deny'
      }
      const currentRole = store.state.currentRole
      const { companyId } = currentRole
      getMyRelease({ ...this.form, ...this.page, excuteCompanyId: companyId, state: s, parentId: 'nullValue', field: 'createTime', order: 'desc' }).then(res => {
        const data = res.data.map.data
        this.total = data.total
        this.tableData = data.rows
      })
    },
    getDataSetByPage () {
      getAllData({ pageSize: 10000 }).then(res => {
        const data = res.data.map.data
        this.dataList = data.rows
      })
    },
    // 数据处理
    dataProcess (raw) {
      return raw.map(i => ({ ...i, ...i.labourAssignRecord }))
    },
    // 接受任务
    handleReceive (item) {
      this.$confirm({
        title: '接受任务',
        content: '确认接受此任务？',
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        onOk: () => {
          updateTask({
            id: item.id,
            state: 'already_accept'
          }).then(res => {
            this.$message.success('接收成功')
            this.getData(1)
          })
        },
        onCancel () {
          console.log('cancel')
        }
      })
    },
    // 拒绝任务
    handleReject (item) {
      this.denyId = item.id
      this.$refs.refuseDialog.open()
      /* this.$confirm({
        title: '拒绝任务',
        content: '确认拒绝此任务',
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        onOk: () => {
          console.log('OK')
          this.$message.success('操作成功')
        },
        onCancel () {
          console.log('cancel')
        }
      }) */
    },
    refuse (item) {
      updateTask({
        id: this.denyId,
        state: 'already_deny',
        excuteNote: item.reason
      }).then(res => {
        this.$message.success('拒绝成功')
        this.$refs.refuseDialog.close()
        this.denyId = ''
        this.getData(1)
      })
    },
    openDetail (item) {
      this.currentItem = item
      this.$refs.taskDetail.open()
    }
  }
}
</script>
<style>
.grey{
  color:#acacac;
  cursor: default;
}
  .grey:hover{
    color:#acacac;
  }
</style>
